<template>
  <div class="channel-list">
    <!-- 页面头部 -->
<!--    <div class="page-header">-->
<!--      <div class="header-left">-->
<!--        <h2 class="page-title"><i class="el-icon-s-custom"></i> 渠道列表</h2>-->
<!--        <span class="page-desc">管理所有渠道帐号信息、审核状态及渠道数据概览</span>-->
<!--      </div>-->
<!--      <div class="header-right">-->
<!--        <el-button icon="el-icon-refresh" size="small" @click="refreshList">刷新</el-button>-->
<!--      </div>-->
<!--    </div>-->

    <!-- 统计概览 -->
    <div class="section-title"><i class="el-icon-data-analysis"></i> 渠道概览</div>
    <el-row :gutter="16" class="stat-row">
      <el-col :span="4">
        <div class="stat-card total">
          <div class="stat-icon">
            <i class="el-icon-user"></i>
          </div>
          <div class="stat-content">
            <div class="stat-label">渠道总数</div>
            <div class="stat-value">{{ overview.totalChannels }}</div>
          </div>
        </div>
      </el-col>
      <el-col :span="4">
        <div class="stat-card active" @click="filterByStatus(1)">
          <div class="stat-icon">
            <i class="el-icon-success"></i>
          </div>
          <div class="stat-content">
            <div class="stat-label">正常渠道</div>
            <div class="stat-value">{{ overview.activeChannels }}</div>
          </div>
        </div>
      </el-col>
      <el-col :span="4">
        <div class="stat-card pending" @click="filterByStatus(0)">
          <div class="stat-icon">
            <i class="el-icon-time"></i>
          </div>
          <div class="stat-content">
            <div class="stat-label">待审核</div>
            <div class="stat-value">{{ overview.pendingChannels }}</div>
          </div>
        </div>
      </el-col>
      <el-col :span="4">
        <div class="stat-card order">
          <div class="stat-icon">
            <i class="el-icon-s-order"></i>
          </div>
          <div class="stat-content">
            <div class="stat-label">渠道订单</div>
            <div class="stat-value">{{ overview.totalOrders }}</div>
          </div>
        </div>
      </el-col>
      <el-col :span="4">
        <div class="stat-card commission">
          <div class="stat-icon">
            <i class="el-icon-coin"></i>
          </div>
          <div class="stat-content">
            <div class="stat-label">佣金总额</div>
            <div class="stat-value">¥{{ overview.totalCommission | filterMoney }}</div>
          </div>
        </div>
      </el-col>
      <el-col :span="4">
        <div class="stat-card withdrawal">
          <div class="stat-icon">
            <i class="el-icon-wallet"></i>
          </div>
          <div class="stat-content">
            <div class="stat-label">提现总额</div>
            <div class="stat-value">¥{{ overview.totalWithdrawal | filterMoney }}</div>
          </div>
        </div>
      </el-col>
    </el-row>

    <!-- 筛选栏 -->
    <div class="filter-bar">
      <el-radio-group v-model="searchForm.status" @change="handleSearch">
        <el-radio-button label="">全部</el-radio-button>
        <el-radio-button
          v-for="item in statusOptions"
          :key="item.value"
          :label="item.value">
          {{ item.label }}
        </el-radio-button>
      </el-radio-group>
      <el-button icon="el-icon-refresh" @click="refreshList">刷新</el-button>
      <el-button type="primary" icon="el-icon-link" @click="showRegisterQrcode">注册二维码</el-button>
    </div>

    <!-- 批量操作栏 -->
    <div v-if="selectedChannels.length > 0" class="batch-action-bar">
      <span class="selected-info">已选择 <strong>{{ selectedChannels.length }}</strong> 个渠道</span>
      <el-button size="small" type="success" @click="handleBatchEnable" :disabled="!canBatchEnable">
        批量启用
      </el-button>
      <el-button size="small" type="warning" @click="handleBatchDisable" :disabled="!canBatchDisable">
        批量禁用
      </el-button>
      <el-button size="small" @click="clearSelection">取消选择</el-button>
    </div>

    <custom-table
      ref="customTable"
      has-organization="true"
      :customOptions="customOptions"
      :columns="columns"
      :add-text="btnPreFn('channel_add', false) ? '新增渠道' : ''"
      :excel-type="btnPreFn('channel_export', false) ? 'ChannelList' : ''"
      @addFn="handleAdd"
      @selection-change="handleSelectionChange">
      <template slot="table-operation">
        <el-table-column label="操作" width="180" fixed="right" align="center">
          <div slot-scope="{row}" class="custom-action">
            <el-button type="text" @click="handleDetail(row)">详情</el-button>
            <el-button v-if="row.status === 1 && btnPreFn('channel_disable')" type="text" @click="handleDisable(row)">禁用</el-button>
            <el-button v-if="row.status === 2 && btnPreFn('channel_enable')" type="text" @click="handleEnable(row)">启用</el-button>
            <el-dropdown @command="handleCommand($event, row)" style="margin-left: 8px;">
              <span class="el-dropdown-link" style="font-size:12px;color:#409EFF;cursor:pointer;">
                更多<i class="el-icon-arrow-down el-icon--right"></i>
              </span>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item command="orders">查看订单</el-dropdown-item>
                <el-dropdown-item command="withdrawal">提现记录</el-dropdown-item>
                <el-dropdown-item command="flow">流水记录</el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </div>
        </el-table-column>
      </template>

      <template slot-scope="{item, row}">
        <template v-if="item.prop === 'channelNo'">
          <div class="channel-no-cell">
            <span class="channel-no" @click="handleDetail(row)">{{ row.channelNo }}</span>
            <el-tag :type="getStatusType(row.status)" size="mini">
              {{ row.status | filterConst('CHANNEL_STATUS') }}
            </el-tag>
          </div>
        </template>
        <template v-else-if="item.prop === 'phone'">
          <div class="phone-cell" @dblclick="$utils.copyText(row.phone)">
            {{ row.phone | filterMaskPhone }}
            <i class="el-icon-document-copy copy-icon" @click.stop="$utils.copyText(row.phone)"></i>
          </div>
        </template>
        <template v-else-if="item.prop === 'orderCount'">
          <span class="link" @click="handleViewOrders(row)">{{ row.orderCount }}</span>
        </template>
        <template v-else-if="item.prop === 'totalCommission'">
          <span class="commission-value">¥{{ row.totalCommission | filterMoney }}</span>
        </template>
        <template v-else-if="item.prop === 'balance'">
          <span class="balance-value" :class="{'positive': row.balance > 0}">
            ¥{{ row.balance | filterMoney }}
          </span>
        </template>
        <template v-else-if="item.prop === 'platformName'">
          <el-tag v-if="row.platformName" size="mini" type="primary" effect="plain">{{ row.platformName }}</el-tag>
          <span v-else class="text-muted">-</span>
        </template>
        <template v-else-if="item.prop === 'created'">
          {{ row.created | filterTime }}
        </template>
        <template v-else>
          <span @dblclick="$utils.dblclickCopy">{{ row[item.prop] || '-' }}</span>
        </template>
      </template>
    </custom-table>

    <!-- 新增渠道抽屉 -->
    <el-drawer
      :visible.sync="addDrawerVisible"
      title="新增渠道"
      size="680px"
      direction="rtl"
      :before-close="handleDrawerClose"
      custom-class="add-channel-drawer">
      <div class="drawer-content">
        <el-form ref="addForm" :model="addForm" :rules="addFormRules" label-width="100px" label-position="top">
          <!-- 基本信息 -->
          <div class="form-section">
            <div class="section-title">
              <i class="el-icon-user"></i>
              <span>基本信息</span>
              <span class="required-tag">必填</span>
            </div>
            <el-row :gutter="20">
              <el-col :span="12">
                <el-form-item label="姓名" prop="name">
                  <el-input v-model="addForm.name" placeholder="请输入渠道姓名" clearable></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="手机号" prop="phone">
                  <el-input v-model="addForm.phone" placeholder="请输入手机号" maxlength="11" clearable></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="密码" prop="password">
                  <el-input v-model="addForm.password" type="password" placeholder="请输入密码" show-password clearable></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="机构名称" prop="organizationId">
                  <el-select v-model="addForm.organizationId" placeholder="请选择机构名称" style="width: 100%;" filterable clearable >
                    <el-option v-for="item in organizationList" :key="item.id" :label="item.name" :value="item.id"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="工作区域" prop="workArea">
                  <el-select
                    v-model="addForm.workArea"
                    placeholder="请选择工作区域"
                    filterable
                    clearable
                    style="width: 100%;">
                    <el-option
                      v-for="station in stationList"
                      :key="station.value"
                      :label="station.label"
                      :value="station.value">
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>
          </div>

          <!-- 证件信息 -->
          <div class="form-section">
            <div class="section-title">
              <i class="el-icon-postcard"></i>
              <span>证件信息</span>
              <span class="optional-tag">选填</span>
            </div>
            <el-row :gutter="20">
              <el-col :span="24">
                <el-form-item label="身份证号" prop="idCard">
                  <el-input v-model="addForm.idCard" placeholder="请输入身份证号" maxlength="18" clearable></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-form-item label="身份证照片">
              <div class="id-card-upload">
                <div class="upload-item">
                  <up-img
                    :file.sync="addForm.idCardFront"
                    width="200"
                    height="140"
                    :cut="false">
                  </up-img>
                </div>
                <div class="upload-item">
                  <up-img
                    :file.sync="addForm.idCardBack"
                    width="200"
                    height="140"
                    :cut="false">
                  </up-img>
                </div>
              </div>
            </el-form-item>
          </div>

          <!-- 收款账户 -->
          <div class="form-section">
            <div class="section-title">
              <i class="el-icon-wallet"></i>
              <span>收款账户</span>
              <span class="optional-tag">选填</span>
            </div>
            <el-row :gutter="20">
              <el-col :span="12">
                <el-form-item label="支付宝账号">
                  <el-input v-model="addForm.alipayAccount" placeholder="请输入支付宝账号" clearable></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="支付宝姓名">
                  <el-input v-model="addForm.alipayName" placeholder="请输入支付宝实名姓名" clearable></el-input>
                </el-form-item>
              </el-col>
            </el-row>
          </div>

          <!-- 备注信息 -->
          <div class="form-section">
            <div class="section-title">
              <i class="el-icon-edit-outline"></i>
              <span>备注信息</span>
              <span class="optional-tag">选填</span>
            </div>
            <el-form-item label="备注">
              <el-input v-model="addForm.remark" type="textarea" :rows="3" placeholder="请输入备注信息" maxlength="200" show-word-limit></el-input>
            </el-form-item>
          </div>
        </el-form>
      </div>

      <!-- 抽屉底部 -->
      <div class="drawer-footer">
        <el-button @click="handleDrawerClose">取消</el-button>
        <el-button type="primary" :loading="addLoading" @click="handleSaveAdd">
          <i class="el-icon-check"></i> 确认提交
        </el-button>
      </div>
    </el-drawer>

    <!-- 注册二维码弹窗 -->
    <el-dialog
      :visible.sync="qrcodeDialogVisible"
      width="480px"
      :close-on-click-modal="false"
      :show-close="false"
      custom-class="channel-register-qrcode-dialog"
      append-to-body>
      <!-- 自定义头部 -->
      <div slot="title" class="dialog-header">
        <div class="header-icon">
          <i class="el-icon-user-solid"></i>
        </div>
        <div class="header-text">
          <h3>渠道注册二维码</h3>
          <p>扫码进行渠道注册</p>
        </div>
        <button class="close-btn" @click="qrcodeDialogVisible = false">
          <i class="el-icon-close"></i>
        </button>
      </div>
      
      <div class="dialog-content">
        <!-- H5 地址输入区域 -->
        <div class="h5-url-section">
          <div class="url-input-wrapper">
            <i class="el-icon-link url-icon"></i>
            <el-input
              v-model="customH5Url"
              placeholder="请输入 H5 地址（留空则使用当前访问地址）"
              clearable
              @change="updateRegisterUrl">
              <template slot="prepend">H5 地址</template>
            </el-input>
          </div>
          <div class="url-tips">
            <i class="el-icon-info"></i>
            <span>提示：通过局域网 IP 访问本页面（如 http://192.168.1.100:3200），生成的二维码其他设备才能扫码</span>
          </div>
        </div>

        <div class="qrcode-wrapper">
          <div class="qrcode-decoration">
            <div class="corner corner-tl"></div>
            <div class="corner corner-tr"></div>
            <div class="corner corner-bl"></div>
            <div class="corner corner-br"></div>
          </div>
          <div class="qrcode-container">
            <vue-qr 
              ref="qrcodeRef"
              class="qr-code-register" 
              :text="registerUrl" 
              :margin="10" 
              colorDark="#409EFF" 
              :size="200" 
            />
          </div>
          <div class="scan-line"></div>
        </div>
        
        <div class="info-section">
          <div class="info-item">
            <i class="el-icon-mobile-phone"></i>
            <span>支持手机扫码注册</span>
          </div>
          <div class="info-item">
            <i class="el-icon-link"></i>
            <span>自动跳转注册页面</span>
          </div>
        </div>
        
        <div class="button-group">
          <el-button class="btn-copy" @click="copyAndOpenRegisterUrl">
            <i class="el-icon-link"></i>
            <span>复制链接</span>
          </el-button>
          <el-button type="primary" class="btn-download" @click="downloadQrcode">
            <i class="el-icon-download"></i>
            <span>下载二维码</span>
          </el-button>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import VueQr from 'vue-qr'

export default {
  name: 'channelList',
  components: {
    VueQr
  },
  data() {
    return {
      qrcodeDialogVisible: false,
      registerUrl: '',
      customH5Url: '', // 自定义 H5 地址
      overview: {
        totalChannels: 0,
        activeChannels: 0,
        pendingChannels: 0,
        totalOrders: 0,
        totalCommission: 0,
        totalWithdrawal: 0
      },
      selectedChannels: [],
      searchForm: {
        status: ''
      },
      customOptions: {
        url: '',
        method: 'get',
        params: {},
        search: [
          { type: 'input', field: 'keyword', name: '关键词', value: '' },
          // {
          //   type: "datetime",
          //   field: "finishTime",
          //   dateProp: {start: "startTime", end: "endTime"},
          //   name: "完成/取消时间",
          //   value: [],
          //   disabledDate: true
          // },
          { type: 'daytime', field: 'Time', name: '注册时间', value: '', clearable: true, disabledDate: true }
        ]
      },
      columns: [
        { label: '所属平台', prop: 'platformName', minWidth: 120, align: 'left' },
        { label: '机构名称', prop: 'organizationName', minWidth: 120, align: 'left' },
        { label: '渠道编号', prop: 'channelNo', minWidth: 190, align: 'left' },
        { label: '姓名', prop: 'name', minWidth: 100, align: 'left' },
        { label: '手机号', prop: 'phone', minWidth: 120, align: 'left' },
        { label: '工作区域', prop: 'workArea', minWidth: 100, align: 'left' },
        { label: '订单数量', prop: 'orderCount', minWidth: 100, align: 'left' },
        { label: '累计乘客', prop: 'totalPassengerCount', minWidth: 100, align: 'left' },
        { label: '累计佣金(元)', prop: 'totalCommission', minWidth: 120, align: 'left' },
        { label: '账户余额(元)', prop: 'balance', minWidth: 120, align: 'left' },
        { label: '注册时间', prop: 'created', minWidth: 160, align: 'left' }
      ],
      // 新增渠道相关
      addDrawerVisible: false,
      addLoading: false,
      organizationList: [],
      stationList: [],
      stationOptions: [],
      stationLoading: false,
      addForm: {
        name: '',
        phone: '',
        password: '',
        idCard: '',
        idCardFront: '',
        idCardBack: '',
        organizationId: '',
        workArea: '',
        alipayAccount: '',
        alipayName: '',
        remark: ''
      },
      addFormRules: {
        name: [{ required: true, message: '请输入渠道姓名', trigger: 'blur' }],
        phone: [
          { required: true, message: '请输入手机号', trigger: 'blur' },
          { pattern: /^1[3-9]\d{9}$/, message: '请输入正确的手机号', trigger: 'blur' }
        ],
        password: [
          { required: true, message: '请输入密码', trigger: 'blur' },
          { min: 6, message: '密码长度不能少于6位', trigger: 'blur' }
        ],
        organizationId: [{ required: true, message: '请选择机构名称', trigger: 'change' }],
        idCard: [{ pattern: /^\d{17}[\dXx]$/, message: '请输入正确的身份证号', trigger: 'blur' }]
      }
    }
  },
  created() {
    this.customOptions.customFn = this.getList
    this.loadOrganizationList()
  },
  mounted() {
    this.$refs.customTable.getList()
    this.loadOverview()
  },
  methods: {
    /**
     * 获取渠道列表
     * 作者：孙艺
     * @param {Object} params - 查询参数
     * @returns {Promise} 返回列表数据
     */
    async getList(params) {
      const searchParams = {
        ...params,
        status: this.searchForm.status
      }
      const res = await this.$axios.get('/api/v1/channel/list', searchParams)
      return res
    },
    handleSearch() {
      this.$refs.customTable.getList()
    },
    handleDetail(row) {
      this.$router.push({
        path: '/channelDetail',
        query: { id: row.id }
      })
    },
    handleViewOrders(row) {
      this.$router.push({
        path: '/channelOrder',
        query: { channelId: row.id }
      })
    },
    /**
     * 禁用渠道
     * 作者：孙艺
     * @param {Object} row - 渠道数据
     */
    handleDisable(row) {
      this.$confirm('确定要禁用该渠道吗？禁用后渠道将无法使用APP', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        const res = await this.$axios.post('/api/v1/channel/updateStatus', {
          id: row.id,
          status: 2
        })
        if (res && res.code === 1) {
          this.$message.success('禁用成功')
          this.$refs.customTable.getList()
          this.loadOverview()
        }
      }).catch(() => {})
    },
    /**
     * 启用渠道
     * 作者：孙艺
     * @param {Object} row - 渠道数据
     */
    handleEnable(row) {
      this.$confirm('确定要启用该渠道吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'info'
      }).then(async () => {
        const res = await this.$axios.post('/api/v1/channel/updateStatus', {
          id: row.id,
          status: 1
        })
        if (res && res.code === 1) {
          this.$message.success('启用成功')
          this.$refs.customTable.getList()
          this.loadOverview()
        }
      }).catch(() => {})
    },
    getStatusType(status) {
      const statusItem = this.$const.CHANNEL_STATUS.find(i => i.value === status)
      return statusItem ? statusItem.type : ''
    },
    handleCommand(command, row) {
      switch (command) {
        case 'orders':
          this.$router.push({
            path: '/channelOrder',
            query: { channelId: row.id }
          })
          break
        case 'withdrawal':
          this.$router.push({
            path: '/channelWithdrawal',
            query: { channelId: row.id }
          })
          break
        case 'flow':
          this.$router.push({
            path: '/channelFinancial',
            query: { channelId: row.id }
          })
          break
      }
    },
    handleSelectionChange(val) {
      this.selectedChannels = val
    },
    clearSelection() {
      this.selectedChannels = []
      this.$refs.customTable.$refs.table.clearSelection()
    },
    /**
     * 批量启用渠道
     * 作者：孙艺
     */
    handleBatchEnable() {
      this.$confirm(`确定要批量启用选中的 ${this.selectedChannels.length} 个渠道吗？`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'info'
      }).then(async () => {
        const disabledChannels = this.selectedChannels.filter(c => c.status === 2)
        if (disabledChannels.length === 0) {
          this.$message.warning('没有可启用的渠道')
          return
        }
        const ids = disabledChannels.map(c => c.id)
        const res = await this.$axios.post('/api/v1/channel/batchUpdateStatus', {
          ids: ids,
          status: 1
        })
        if (res && res.code === 1) {
          this.$message.success(`成功启用 ${disabledChannels.length} 个渠道`)
          this.clearSelection()
          this.$refs.customTable.getList()
          this.loadOverview()
        }
      }).catch(() => {})
    },
    /**
     * 批量禁用渠道
     * 作者：孙艺
     */
    handleBatchDisable() {
      this.$confirm(`确定要批量禁用选中的 ${this.selectedChannels.length} 个渠道吗？禁用后渠道将无法使用APP`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        const activeChannels = this.selectedChannels.filter(c => c.status === 1)
        if (activeChannels.length === 0) {
          this.$message.warning('没有可禁用的渠道')
          return
        }
        const ids = activeChannels.map(c => c.id)
        const res = await this.$axios.post('/api/v1/channel/batchUpdateStatus', {
          ids: ids,
          status: 2
        })
        if (res && res.code === 1) {
          this.$message.success(`成功禁用 ${activeChannels.length} 个渠道`)
          this.clearSelection()
          this.$refs.customTable.getList()
          this.loadOverview()
        }
      }).catch(() => {})
    },
    /**
     * 加载统计概览数据
     * 作者：孙艺
     */
    async loadOverview() {
      const res = await this.$axios.get('/api/v1/channel/overview')
      if (res && res.code === 1) {
        this.overview = {
          totalChannels: res.data.totalChannels,
          activeChannels: res.data.activeChannels,
          pendingChannels: res.data.pendingChannels,
          totalOrders: res.data.totalOrders,
          totalCommission: parseFloat(res.data.totalCommission),
          totalWithdrawal: parseFloat(res.data.totalWithdrawal)
        }
      }
    },
    /**
     * 加载机构列表
     * 作者：孙艺
     */
    async loadOrganizationList() {
      const res = await this.$axios.get('/api/v1/manage/organization/queryByAdminId')
      if (res && res.code === 1) {
        this.organizationList = res.data
      }
    },
    /**
     * 机构选择变化时加载场站列表
     * 作者：孙艺
     * @param {Number} orgId - 机构ID
     */
    async handleOrgChange(orgId) {
      this.addForm.workArea = ''
      this.stationList = []
      if (!orgId) return
      this.stationLoading = true
      try {
        const res = await this.$axios.get('/api/v1/channel/station/list', { organizationId: orgId })
        if (res && res.code === 1) {
          this.stationList = (res.data || []).map(s => ({ label: s.stationName || s.name, value: s.stationName || s.name }))
        }
      } finally {
        this.stationLoading = false
      }
    },
    getStationIcon(type) {
      const icons = {
        '机场': 'el-icon-plane',
        '高铁站': 'el-icon-truck',
        '火车站': 'el-icon-truck',
        '景区': 'el-icon-place',
        '商圈': 'el-icon-goods'
      }
      return icons[type] || 'el-icon-location'
    },
    refreshList() {
      this.$refs.customTable.getList()
      this.loadOverview()
    },
    filterByStatus(status) {
      this.searchForm.status = status
      this.handleSearch()
    },
    async handleAdd() {
      this.addForm = {
        name: '',
        phone: '',
        password: '',
        idCard: '',
        idCardFront: '',
        idCardBack: '',
        organizationId: '',
        workArea: '',
        alipayAccount: '',
        alipayName: '',
        remark: ''
      }
      // 加载场站列表
      const appKey = this.mixinUserInfo?.appKey
      this.stationList = await this.mixinGetStationList(appKey)
      this.addDrawerVisible = true
      this.$nextTick(() => {
        this.$refs.addForm && this.$refs.addForm.clearValidate()
      })
    },
    handleDrawerClose(done) {
      if (this.addForm.name || this.addForm.phone) {
        this.$confirm('表单内容未保存，确定关闭吗？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          if (typeof done === 'function') {
            done()
          } else {
            this.addDrawerVisible = false
          }
        }).catch(() => {})
      } else {
        if (typeof done === 'function') {
          done()
        } else {
          this.addDrawerVisible = false
        }
      }
    },
    getOrganizationName(id) {
      const org = this.organizationList.find(item => item.id === id)
      return org ? org.name : ''
    },
    /**
     * 保存新增渠道
     * 作者：孙艺
     */
    handleSaveAdd() {
      this.$refs.addForm.validate(async (valid) => {
        if (valid) {
          this.addLoading = true
          // 对密码进行 sha256 加密
          const formData = {
            ...this.addForm,
            password: this.$utils.sha256Fn(this.addForm.password)
          }
          
          const res = await this.$axios.post('/api/v1/channel/add', formData)
          this.addLoading = false
          if (res && res.code === 1) {
            this.$message.success('新增渠道成功')
            this.addDrawerVisible = false
            this.$refs.customTable.getList()
            this.loadOverview()
          } else {
            this.$message.error(res.msg || '新增失败')
          }
        }
      })
    },
    showRegisterQrcode() {
      console.log(">>>>>>>")
      // 优先使用配置的 H5 地址
      if (window.configure?.h5BaseUrl) {
        this.customH5Url = window.configure.h5BaseUrl
      } else {
        // 开发环境：智能判断
        const hostname = window.location.hostname
        const isLocalhost = hostname === 'localhost' || hostname === '127.0.0.1'

        if (isLocalhost && process.env.NODE_ENV === 'development') {
          // localhost 访问，清空自定义地址，提示用户
          this.customH5Url = ''
        } else {
          // 局域网或生产环境，使用当前 origin
          this.customH5Url = window.location.origin
        }
      }

      this.updateRegisterUrl()
      this.qrcodeDialogVisible = true
    },
    updateRegisterUrl() {
      const baseUrl = this.customH5Url || window.location.origin
      this.registerUrl = `${baseUrl}/#/channel-register?appKey=${this.mixinUserInfo.appKey}`
      console.log('二维码 URL:', this.registerUrl)
    },
    copyRegisterUrl() {
      this.$utils.copyText(this.registerUrl)
    },
    copyAndOpenRegisterUrl() {
      const input = document.createElement('input')
      document.body.appendChild(input)
      input.setAttribute('value', this.registerUrl)
      input.select()
      if (document.execCommand('copy')) {
        document.execCommand('copy')
        this.$message.success("链接已复制")
      } else {
        this.$message.info("该浏览器不支持复制，请手动复制地址栏链接")
      }
      document.body.removeChild(input)

      setTimeout(() => {
        window.open(this.registerUrl)
      }, 500)
    },
    downloadQrcode() {
      let oQrcode = document.getElementsByClassName("qr-code-register")[0]
      if (!oQrcode) {
        this.$message.warning('二维码未生成')
        return
      }
      let a = document.createElement("a")
      a.href = oQrcode.src
      a.download = "渠道注册二维码"
      a.click()
    }
  },
  computed: {
    canBatchEnable() {
      return this.selectedChannels.some(c => c.status === 2)
    },
    canBatchDisable() {
      return this.selectedChannels.some(c => c.status === 1)
    },
    statusOptions() {
      return this.$const.CHANNEL_STATUS || []
    }
  }
}
</script>

<style lang="less" scoped>
@import '../channel.less';

// 页面容器
.channel-list {
  height: 100%;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

// 批量操作栏
.batch-bar {
  flex-shrink: 0;
}

// 列表单元格样式
.channel-no-cell {
  display: flex;
  align-items: center;
  gap: 8px;

  .channel-no {
    color: #409EFF;
    cursor: pointer;
    font-weight: 500;

    &:hover {
      text-decoration: underline;
    }
  }
}

.phone-cell {
  display: flex;
  align-items: center;

  .copy-icon {
    margin-left: 6px;
    color: #C0C4CC;
    cursor: pointer;
    opacity: 0;
    transition: opacity 0.2s;

    &:hover { color: #409EFF; }
  }

  &:hover .copy-icon {
    opacity: 1;
  }
}

.commission-value {
  color: #67C23A;
  font-weight: 500;
  display: block;
  text-align: right;
}

.balance-value {
  color: #909399;
  display: block;
  text-align: right;

  &.positive {
    color: #67C23A;
    font-weight: 600;
  }
}

.link {
  display: block;
  text-align: right;
}

// 抽屉样式
/deep/ .add-channel-drawer {
  .el-drawer__header {
    margin-bottom: 0;
    padding: 16px 20px;
    border-bottom: 1px solid #EBEEF5;
    font-size: 16px;
    font-weight: 600;
    color: #303133;
  }

  .el-drawer__body {
    padding: 0;
    display: flex;
    flex-direction: column;
    height: calc(100% - 57px);
  }
}

.drawer-content {
  flex: 1;
  overflow-y: auto;
  padding: 20px;
  padding-bottom: 80px;

  &::-webkit-scrollbar {
    width: 6px;
  }

  &::-webkit-scrollbar-thumb {
    background: #dcdfe6;
    border-radius: 3px;
  }

  &::-webkit-scrollbar-track {
    background: transparent;
  }
}

// 表单区块
.form-section {
  background: #fff;
  border: 1px solid #EBEEF5;
  border-radius: 8px;
  padding: 20px;
  margin-bottom: 16px;

  &:last-child {
    margin-bottom: 0;
  }

  .section-title {
    display: flex;
    align-items: center;
    gap: 8px;
    margin-bottom: 20px;
    padding-bottom: 12px;
    border-bottom: 1px solid #f0f0f0;
    font-size: 15px;
    font-weight: 600;
    color: #303133;

    i {
      font-size: 16px;
      color: #409EFF;
    }

    .required-tag {
      margin-left: auto;
      font-size: 12px;
      color: #F56C6C;
      background: #FEF0F0;
      padding: 2px 8px;
      border-radius: 4px;
    }

    .optional-tag {
      font-size: 12px;
      color: #909399;
      font-weight: normal;
    }
  }

  /deep/ .el-form-item__label {
    font-weight: 500;
    color: #606266;
  }

  /deep/ .el-input__inner {
    border-radius: 6px;
  }

  /deep/ .el-select {
    .el-input__inner {
      border-radius: 6px;
    }
  }

  /deep/ .el-textarea__inner {
    border-radius: 6px;
  }
}

// 身份证上传
.id-card-upload {
  display: flex;
  gap: 20px;

  .upload-item {
    flex: 1;

    .upload-label {
      font-size: 13px;
      color: #606266;
      margin-bottom: 8px;
      text-align: center;
    }
  }
}

.id-card-uploader {
  /deep/ .el-upload {
    width: 100%;
  }

  .upload-box {
    width: 100%;
    height: 140px;
    border: 2px dashed #DCDFE6;
    border-radius: 8px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    transition: all 0.3s;
    background: #fafafa;

    &:hover {
      border-color: #409EFF;
      background: #409EFF08;
    }

    i {
      font-size: 28px;
      color: #C0C4CC;
      margin-bottom: 8px;
    }

    span {
      font-size: 13px;
      color: #909399;
    }
  }

  .upload-preview {
    width: 100%;
    height: 140px;
    border-radius: 8px;
    overflow: hidden;
    position: relative;

    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
    }

    .preview-mask {
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      background: rgba(0, 0, 0, 0.5);
      display: flex;
      align-items: center;
      justify-content: center;
      opacity: 0;
      transition: opacity 0.3s;

      i {
        font-size: 24px;
        color: #fff;
        cursor: pointer;

        &:hover {
          color: #F56C6C;
        }
      }
    }

    &:hover .preview-mask {
      opacity: 1;
    }
  }
}

.upload-tips {
  display: flex;
  align-items: center;
  gap: 6px;
  margin-top: 12px;
  font-size: 12px;
  color: #909399;

  i { color: #409EFF; }
}

// 抽屉底部
.drawer-footer {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  padding: 16px 24px;
  background: #fff;
  border-top: 1px solid #EBEEF5;
  display: flex;
  justify-content: flex-end;
  gap: 12px;
  box-shadow: 0 -2px 8px rgba(0, 0, 0, 0.04);

  .el-button {
    min-width: 88px;
    border-radius: 6px;
  }

  .el-button--primary {
    background: linear-gradient(135deg, #409EFF 0%, #66B1FF 100%);
    border: none;

    &:hover {
      background: linear-gradient(135deg, #66B1FF 0%, #409EFF 100%);
    }
  }
}

// 二维码弹窗
// 二维码弹窗样式
.dialog-content {
  padding: 0 20px 20px;
}

// H5 地址输入区域
.h5-url-section {
  margin-bottom: 20px;
  padding: 16px;
  background: #f8fafc;
  border-radius: 12px;
  border: 1px solid #e2e8f0;

  .url-input-wrapper {
    display: flex;
    align-items: center;
    gap: 8px;
    margin-bottom: 8px;

    .url-icon {
      font-size: 18px;
      color: #409EFF;
      flex-shrink: 0;
    }

    /deep/ .el-input-group {
      flex: 1;
    }

    /deep/ .el-input-group__prepend {
      background: #409EFF;
      color: #fff;
      border-color: #409EFF;
      font-weight: 500;
      padding: 0 15px;
    }

    /deep/ .el-input__inner {
      border-radius: 0 6px 6px 0;
    }
  }

  .url-tips {
    display: flex;
    align-items: flex-start;
    gap: 6px;
    font-size: 12px;
    color: #64748b;
    line-height: 1.5;

    i {
      color: #409EFF;
      margin-top: 2px;
      flex-shrink: 0;
    }
  }
}

.qrcode-wrapper {
  text-align: center;
  padding: 30px;
  background: linear-gradient(135deg, #ecf5ff 0%, #d9ecff 50%, #ecf5ff 100%);
  border-radius: 16px;
  margin-bottom: 20px;
  position: relative;
  overflow: hidden;
  
  // 装饰角
  .qrcode-decoration {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 230px;
    height: 230px;
    pointer-events: none;
    
    .corner {
      position: absolute;
      width: 20px;
      height: 20px;
      border: 3px solid #409EFF;
      
      &.corner-tl {
        top: 0;
        left: 0;
        border-right: none;
        border-bottom: none;
        border-radius: 4px 0 0 0;
      }
      
      &.corner-tr {
        top: 0;
        right: 0;
        border-left: none;
        border-bottom: none;
        border-radius: 0 4px 0 0;
      }
      
      &.corner-bl {
        bottom: 0;
        left: 0;
        border-right: none;
        border-top: none;
        border-radius: 0 0 0 4px;
      }
      
      &.corner-br {
        bottom: 0;
        right: 0;
        border-left: none;
        border-top: none;
        border-radius: 0 0 4px 0;
      }
    }
  }
  
  .qrcode-container {
    display: inline-block;
    padding: 12px;
    background: #fff;
    border-radius: 12px;
    box-shadow: 0 8px 32px rgba(64, 158, 255, 0.2);
    position: relative;
    z-index: 1;
  }
  
  // 扫描线动画
  .scan-line {
    position: absolute;
    top: 30px;
    left: 50%;
    transform: translateX(-50%);
    width: 200px;
    height: 2px;
    background: linear-gradient(90deg, transparent, #409EFF, transparent);
    animation: scan 2s ease-in-out infinite;
    opacity: 0.8;
  }
}

@keyframes scan {
  0%, 100% {
    top: 30px;
    opacity: 0;
  }
  50% {
    opacity: 0.8;
  }
  100% {
    top: calc(100% - 30px);
    opacity: 0;
  }
}

.info-section {
  display: flex;
  justify-content: center;
  gap: 24px;
  margin-bottom: 24px;
  padding: 16px;
  background: #f8fafc;
  border-radius: 12px;
  
  .info-item {
    display: flex;
    align-items: center;
    font-size: 13px;
    color: #64748b;
    
    i {
      font-size: 16px;
      color: #409EFF;
      margin-right: 6px;
    }
  }
}

.button-group {
  display: flex;
  justify-content: center;
  gap: 16px;
  
  .el-button {
    min-width: 140px;
    height: 44px;
    border-radius: 22px;
    font-weight: 500;
    font-size: 14px;
    transition: all 0.3s ease;
    
    i {
      margin-right: 6px;
    }
    
    &.btn-copy {
      border: 2px solid #e2e8f0;
      color: #475569;
      
      &:hover {
        border-color: #409EFF;
        color: #409EFF;
        background: #ecf5ff;
      }
    }
    
    &.btn-download {
      background: linear-gradient(135deg, #409EFF 0%, #337ecc 100%);
      border: none;
      
      &:hover {
        transform: translateY(-2px);
        box-shadow: 0 6px 20px rgba(64, 158, 255, 0.4);
      }
    }
  }
}

// 场站选项样式
.station-option {
  display: flex;
  align-items: center;
  gap: 8px;

  i {
    color: #409EFF;
    font-size: 14px;
  }

  .el-tag {
    margin-left: auto;
  }
}
</style>

<!-- 全局样式 - 二维码弹窗 -->
<style lang="less">
.channel-register-qrcode-dialog {
  .el-dialog {
    border-radius: 20px;
    overflow: hidden;
    box-shadow: 0 20px 60px rgba(0, 0, 0, 0.15);
  }
  
  .el-dialog__header {
    padding: 0;
    margin: 0;
  }
  
  .el-dialog__body {
    padding: 0;
  }
  
  .dialog-header {
    display: flex;
    align-items: center;
    padding: 20px 24px;
    background: linear-gradient(135deg, #409EFF 0%, #337ecc 100%);
    color: #fff;
    position: relative;
    
    .header-icon {
      width: 48px;
      height: 48px;
      border-radius: 12px;
      background: rgba(255, 255, 255, 0.2);
      display: flex;
      align-items: center;
      justify-content: center;
      margin-right: 16px;
      
      i {
        font-size: 24px;
      }
    }
    
    .header-text {
      flex: 1;
      
      h3 {
        margin: 0;
        font-size: 18px;
        font-weight: 600;
      }
      
      p {
        margin: 4px 0 0;
        font-size: 13px;
        opacity: 0.9;
      }
    }
    
    .close-btn {
      width: 32px;
      height: 32px;
      border-radius: 50%;
      border: none;
      background: rgba(255, 255, 255, 0.2);
      color: #fff;
      cursor: pointer;
      display: flex;
      align-items: center;
      justify-content: center;
      transition: all 0.3s ease;
      
      &:hover {
        background: rgba(255, 255, 255, 0.3);
        transform: rotate(90deg);
      }
      
      i {
        font-size: 16px;
      }
    }
  }
}
</style>
